import { IValidation } from "../Validations/IValidation";

export type ObjectFromList<T extends ReadonlyArray<string>, V = string> = {
  [K in T extends ReadonlyArray<infer U> ? U : never]: V;
};

export enum FormControlDependsOnThenEnum {
  IsRequired,
  Hide,
  Disable,
  SetValue,
  AddValidations,
  SetFocus
}

export type FormControlDependsOnSchema<TProperties extends readonly string[] = any> =
  | IsRequiredFormControlDependsOnSchema<TProperties>
  | HideFormControlDependsOnSchema<TProperties>
  | DisableFormControlDependsOnSchema<TProperties>
  | SetValueFormControlDependsOnSchema<TProperties>
  | AddValidationsFormControlDependsOnSchema<TProperties>
  | SetFocusFormControlDependsOnSchema<TProperties>;

export interface IsRequiredFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.IsRequired;
}

export interface HideFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.Hide;
}

export interface DisableFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.Disable;
}

export interface SetValueFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.SetValue;

  setWithValue:
    | any
    | ((
        dependsOnValues: ObjectFromList<TProperties, string | Array<any> | undefined | null>,
        formValues: Record<string, any>
      ) => any);
}

export interface AddValidationsFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.AddValidations;

  addValidations: (
    dependsOnValues: ObjectFromList<TProperties, string | Array<any> | undefined | null>
  ) => IValidation[];
}

export interface SetFocusFormControlDependsOnSchema<TProperties extends readonly string[] = any>
  extends IFormControlDependsOnSchema<TProperties> {
  then: FormControlDependsOnThenEnum.SetFocus;
}

export interface IFormControlDependsOnSchema<TProperties extends readonly string[] = any> {
  isAbsolutePropertyPath?: boolean;
  properties: TProperties;
  if: (value: ObjectFromList<TProperties, string | Array<any> | undefined | null>) => boolean;
  then: FormControlDependsOnThenEnum;
}

export class CreateDependsOnFactory {
  static create = <TProperties extends readonly string[]>(
    props: FormControlDependsOnSchema<TProperties>
  ): FormControlDependsOnSchema<TProperties> => ({
    ...props
  });
}
